import { Btn } from "../../global/Buttons/btns";
import { Title } from "../../global/title/title";

export const ContactUS = () => {
  return (
    <div className="contactUs section">
      <div className="container">
        <Title black="Contact" blue="Us" />
        <div className="contactUs__content pad--large">
          <div className="contactUs__side">
            <div className="flex-gap">
              <div className="contactUs__icon">
                <Location />
              </div>
              <h2>4517 Washington Ave. Manchester, Kentucky 39495</h2>
            </div>
            <div className="flex-gap">
              <div className="contactUs__icon">
                <Msg />
              </div>

              <h2>georgia@example.com</h2>
            </div>
            <div className="flex-gap">
              <div className="contactUs__icon">
                <Phone />
              </div>
              <h2>(704) 555-0127</h2>
            </div>
          </div>
          <form className="contactUs__side contactUs__form">
            <div className="input-box">
              <label htmlFor="name" className="input__label">
                Name:
              </label>
              <input
                type="text"
                name="name"
                className="input"
                placeholder="Enter your name"
              />
            </div>
            <div className="input-box">
              <label htmlFor="name" className="input__label">
                Email:
              </label>
              <input
                type="text"
                name="email"
                className="input"
                placeholder="Enter your email"
              />
            </div>
            <div className="input-box">
              <label htmlFor="name" className="input__label">
                message:
              </label>
              <textarea
                className=" input input__textarea"
                name="message"
                placeholder="Enter your message"
              ></textarea>
            </div>
            <div className="align-self">
              <Btn name="secondary" value="send" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
const Location = () => {
  return (
    <svg
      width="72"
      height="62"
      viewBox="0 0 72 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72" height="62" rx="10" fill="#246BFD" />
      <path
        d="M36 42.25C34.4212 40.9033 32.9577 39.4269 31.625 37.8362C29.625 35.4475 27.25 31.89 27.25 28.5C27.2491 26.7687 27.7619 25.076 28.7234 23.6363C29.6848 22.1965 31.0518 21.0743 32.6513 20.4117C34.2508 19.7492 36.0109 19.576 37.7089 19.9141C39.4069 20.2522 40.9663 21.0865 42.19 22.3112C43.0047 23.1223 43.6504 24.0869 44.0899 25.1492C44.5293 26.2115 44.7537 27.3504 44.75 28.5C44.75 31.89 42.375 35.4475 40.375 37.8362C39.0423 39.4269 37.5788 40.9033 36 42.25ZM36 22.25C34.343 22.252 32.7544 22.9111 31.5828 24.0828C30.4111 25.2544 29.752 26.843 29.75 28.5C29.75 29.9575 30.4088 32.4812 33.5438 36.2325C34.3164 37.1551 35.1363 38.0371 36 38.875C36.8638 38.038 37.684 37.1573 38.4575 36.2362C41.5913 32.48 42.25 29.9562 42.25 28.5C42.248 26.843 41.5889 25.2544 40.4172 24.0828C39.2456 22.9111 37.657 22.252 36 22.25ZM36 32.25C35.0054 32.25 34.0516 31.8549 33.3484 31.1516C32.6451 30.4484 32.25 29.4946 32.25 28.5C32.25 27.5054 32.6451 26.5516 33.3484 25.8483C34.0516 25.1451 35.0054 24.75 36 24.75C36.9946 24.75 37.9484 25.1451 38.6517 25.8483C39.3549 26.5516 39.75 27.5054 39.75 28.5C39.75 29.4946 39.3549 30.4484 38.6517 31.1516C37.9484 31.8549 36.9946 32.25 36 32.25Z"
        fill="white"
      />
    </svg>
  );
};
const Msg = () => {
  return (
    <svg
      width="72"
      height="62"
      viewBox="0 0 72 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72" height="62" rx="10" fill="#246BFD" />
      <path
        d="M28.5 21.625C27.5054 21.625 26.5516 22.0201 25.8483 22.7233C25.1451 23.4266 24.75 24.3804 24.75 25.375V25.7519L36 31.81L47.25 25.7538V25.375C47.25 24.3804 46.8549 23.4266 46.1516 22.7233C45.4484 22.0201 44.4946 21.625 43.5 21.625H28.5ZM47.25 27.8819L36.4444 33.7C36.3078 33.7735 36.1551 33.812 36 33.812C35.8449 33.812 35.6922 33.7735 35.5556 33.7L24.75 27.8819V36.625C24.75 37.6196 25.1451 38.5734 25.8483 39.2766C26.5516 39.9799 27.5054 40.375 28.5 40.375H43.5C44.4946 40.375 45.4484 39.9799 46.1516 39.2766C46.8549 38.5734 47.25 37.6196 47.25 36.625V27.8819Z"
        fill="white"
      />
    </svg>
  );
};
const Phone = () => {
  return (
    <svg
      width="72"
      height="62"
      viewBox="0 0 72 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72" height="62" rx="10" fill="#246BFD" />
      <path
        d="M39.0228 22.8624C38.4278 22.7525 37.8813 23.1323 37.768 23.7131C37.6547 24.294 38.0356 24.8611 38.6145 24.9747C40.3573 25.3145 41.703 26.6636 42.0441 28.4124V28.4136C42.1412 28.917 42.5844 29.283 43.0948 29.283C43.1633 29.283 43.2318 29.2768 43.3015 29.2643C43.8803 29.1481 44.2613 28.5823 44.148 28.0002C43.6388 25.3882 41.6284 23.3708 39.0228 22.8624Z"
        fill="white"
      />
      <path
        d="M38.9451 18.5099C38.6662 18.4699 38.3861 18.5524 38.1633 18.7298C37.9342 18.9096 37.7911 19.1695 37.7599 19.4605C37.694 20.0489 38.1185 20.581 38.706 20.6472C42.7581 21.0994 45.9077 24.256 46.3633 28.3207C46.4243 28.8653 46.8811 29.2763 47.4264 29.2763C47.4675 29.2763 47.5073 29.2738 47.5484 29.2688C47.8335 29.2375 48.0874 29.0964 48.2667 28.8715C48.4447 28.6467 48.5256 28.3669 48.4933 28.0808C47.9256 23.0093 44.0005 19.0733 38.9451 18.5099Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.7897 32.2155C39.776 37.2005 40.9072 31.4334 44.0821 34.606C47.1428 37.6659 48.902 38.279 45.024 42.1559C44.5383 42.5463 41.452 47.2428 30.6058 36.3996C19.7582 25.555 24.452 22.4656 24.8425 21.9799C28.7298 18.0923 29.3323 19.8617 32.3931 22.9217C35.568 26.0956 29.8033 27.2305 34.7897 32.2155Z"
        fill="white"
      />
    </svg>
  );
};
